import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * Görev Yetkileri (İnsan Kaynakları > Tanımlamalar, QR Mesai Faz 2, 18.10.2026).
 * Görev = Sabit Tanımlar › Personel Görevi (PERSONNEL_DUTY). Her göreve okutabileceği QR türleri (Depo / Ofis / Araç)
 * ve mobil ana sayfada mesai başlayınca açılan kartlar (Görevlerim / Mesai Planlama) verilir.
 * Satırı olmayan görev varsayılanla döner (Depo açık).
 */

export interface GorevYetkisiSatiri {
    gorevId: string
    gorevAdi: string
    depo: boolean
    ofis: boolean
    arac: boolean
    gorevlerim: boolean
    mesaiPlanlama: boolean
    mesaiOnay: boolean
    /** İzin ve gün değişimi isteklerini onaylar (personel kartında özel onaylayıcı yoksa; İK Faz 3). */
    izinOnay: boolean
    /** Bu görevdeki personel sayısı (bilgi). */
    personelSayisi: number
}

export type GorevYetkisiAlani = 'depo' | 'ofis' | 'arac' | 'gorevlerim' | 'mesaiPlanlama' | 'mesaiOnay' | 'izinOnay';

export interface GorevYetkisiKaydetIstegi {
    satirlar: Omit<GorevYetkisiSatiri, 'gorevAdi' | 'personelSayisi'>[]
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - GorevYetkisi/' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/GorevYetkisi/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class GorevYetkisiService {
    static liste = () => cagir<GorevYetkisiSatiri[]>('Liste');
    static kaydet = (istek: GorevYetkisiKaydetIstegi) => cagir<boolean>('Kaydet', istek);
}
